import React from 'react';
import Link from 'next/link';
import { SEARCH_PAGE } from '@core/ui/navigation/constant';
import BreadcrumbStyled from './Breadcrumb.style.js';
import homeIcon from '@core/ui/static/images/ico-home.svg';
import { useTranslation } from 'next-i18next';
import { slugify } from '../../helpers/urlHandler';
import { truncateTitle } from '../../helpers/textHelpers';

const Breadcrumb = ({ category, town, title }) => {
  const { t } = useTranslation();

  const breadcrumbItems = [
    {
      label: (
        <img
          src={homeIcon}
          alt="Accueil"
          style={{ verticalAlign: 'text-top' }}
        />
      ),
      url: '/',
    },
  ];
  if (town) {
    breadcrumbItems.push({
      label: town,
      url: `/${SEARCH_PAGE}/all?town=${town.trim()}`,
    });
  }
  if (category) {
    breadcrumbItems.push({
      label: t('category.' + category),
      url: `/${SEARCH_PAGE}/${slugify(category)}`,
    });
  }
  if (title) {
    breadcrumbItems.push({ label: title });
  }

  const hasLink = (breadcrumbItems, i) => {
    const item = breadcrumbItems[i];
    const isLast = breadcrumbItems.length - 1 === i;
    if (item.url && !isLast) {
      return true;
    }
    return false;
  };

  return (
    <BreadcrumbStyled>
      {breadcrumbItems.map((breadcrumbItem, i) => (
        <li key={i}>
          {hasLink(breadcrumbItems, i) ? (
            <Link href={`${breadcrumbItem.url}`}>
              <a>{truncateTitle(breadcrumbItem.label)}</a>
            </Link>
          ) : (
            truncateTitle(breadcrumbItem.label)
          )}
        </li>
      ))}
    </BreadcrumbStyled>
  );
};

export default Breadcrumb;
